import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router, Switch, Route, Redirect,
} from 'react-router-dom';
import axios from 'axios';
import safeCompare from 'safe-compare';
import UserPage from '../pages/UserPage';
import Page404 from '../pages/Page404';
import Login from '../pages/authentication/Login';
import BackOffice from '../pages/BackOffice';
import 'bootstrap/dist/css/bootstrap.min.css';
import adminContext from '../context/adminContext';
import PasswordRecover from '../pages/authentication/PasswordRecover';
import EmailValidation from '../pages/authentication/EmailValidation';
import PasswordEdit from '../components/PasswordEdit';

function App() {
  const [userData, setUserData] = useState({
    token: 'LOADING',
    userId: 'LOADING',
    usages: 'LOADING',
    isAdmin: 'LOADING',
  });

  useEffect(() => {
    const checkLoggedIn = async () => {
      const token = localStorage.getItem('auth-token');

      //  User is not logged in
      if (safeCompare(token, '') || safeCompare(token, null) || safeCompare(token, 'INVALID')) {
        setUserData({
          token: 'INVALID',
          userId: 'INVALID',
          isAdmin: 'INVALID',
          usages: 'first',
        });
        return;
      }

      try {
        const tokenResponse = await axios.post(
          `${process.env.REACT_APP_API_URI}/api/authentication`,
          null,
          {
            headers: { authorization: `token ${token}` },
          },
        );

        if (tokenResponse !== undefined && tokenResponse.data) {
          setUserData({
            token,
            userId: tokenResponse.data.user_id,
            isAdmin: tokenResponse.data.isAdmin,
          });
        } else {
          setUserData({
            token: 'INVALID',
            userId: 'INVALID',
            isAdmin: 'INVALID',
            usages: 'first',
          });
        }
      } catch {
        setUserData({
          token: 'INVALID',
          userId: 'INVALID',
          isAdmin: 'INVALID',
          usages: 'first',
        });
      }
    };

    checkLoggedIn();
  }, []);

  useEffect(() => {
    if (
      userData.token === 'INVALID'
      && window.location.pathname !== '/login'
      && window.location.pathname !== '/register'
      && window.location.pathname !== '/request_password_recover'
      && !/\/confirmation\/*/.test(window.location.pathname)
      && !/\/password_recover\/*/.test(window.location.pathname)
      && !/\/create-password\/*/.test(window.location.pathname)
    ) {
      // window.location.href = '/login';
    }
  }, [userData.token]);

  return (
    <Router>
      <adminContext.Provider value={{ userData, setUserData }}>
        <Switch>
          <Route
            exact
            path="/"
            render={() => (userData.isAdmin && userData.isAdmin !== 'INVALID' ? <UserPage isAdmin /> : <UserPage />)}
          />
          <Route
            path="/login"
            component={Login}
          />
          <Route
            path="/request_password_recover"
            component={EmailValidation}
          />
          <Route
            exact
            path="/password_recover/:token"
            component={PasswordRecover}
          />
          <Route
            exact
            path="/password_update/:token"
            component={PasswordEdit}
          />
          <Route
            path="/backoffice"
            render={() => (userData.isAdmin && userData.isAdmin !== 'INVALID' ? <BackOffice /> : <Redirect to="/login" />)}
          />
          <Route component={Page404} />
        </Switch>
      </adminContext.Provider>
    </Router>
  );
}

export default App;
